import React, { useRef } from "react";
import ToolTipComponent from "components/common/Tooltip/Tooltip";
import BannerTooltipBody from "./BannerTooltipBody/BannerTooltipBody";
import { IBannerCardComponentProps } from "./BannerCardComponent.interface";
import { STATUS } from "config/constants";
import BazaarLogo from "assets/banner-sample.svg";

import "./BannerCardComponent.scss";

const BannerCardComponent = (props: IBannerCardComponentProps) => {
  const { clickHandler, banner } = props;
  const ref = useRef(`banner-tooltip-${banner.id}`);

  return (
    <div id={ref.current} className="banner-card" onClick={clickHandler}>
      {banner.status === STATUS.INACTIVE && (
        <div className="disabled-layer"></div>
      )}
      <img
        src={banner.w400Xh400.base64StringUrl || BazaarLogo}
        alt="banner"
        className="banner-image"
      />
      {/* <div className="title-text">
        <h5>{banner.bannerTitle}</h5>
      </div> */}
      <ToolTipComponent targetId={ref.current}>
        <BannerTooltipBody banner={banner} />
      </ToolTipComponent>
    </div>
  );
};

export default BannerCardComponent;
